function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import ScrollReveal from "scrollreveal";
document.addEventListener("DOMContentLoaded", function () {
  //if desktop and NOT IE
  //	if(window.matchMedia("(min-width: 1280px)").matches && !((navigator.userAgent).indexOf("MSIE ") > -1 || (navigator.userAgent).indexOf("Trident/") > -1)) {
  //if NOT IE
  if (!(navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1) && !document.body.classList.contains('single-product')) {
    // #region Posters
    ScrollReveal().reveal('.poster', {
      delay: 600,
      scale: 1.4,
      easing: 'ease-out',
      duration: 200,
      opacity: 0,
      interval: 300,
      beforeReveal: function beforeReveal(el) {
        setTimeout(function () {
          el.classList.remove('opacity-0');
          el.classList.add('pasted');
          setTimeout(function () {
            el.style = '';
          }, 500);
        }, 600);
      }
    }); // #endregion
    // #region Stickers

    ScrollReveal().reveal('.sticker', {
      easing: 'ease-out',
      delay: 200,
      duration: 200,
      opacity: 0,
      beforeReveal: function beforeReveal(el) {
        //if gsap is loaded
        if (typeof gsap !== 'undefined' && gsap) {
          var id = '#' + el.id;
          var peel = el.dataset.peel === 'true';
          var peelTL = gsap.timeline({
            paused: true,
            reversed: true,
            defaults: {
              duration: 0.75,
              ease: "power1.inOut"
            }
          });
          peelTL.from(id, {
            duration: 0.1,
            opacity: 0
          }, 0).from(id, {
            scale: 5
          }, 0).from(id + ' .sticky', {
            rotation: 10
          }, 0).from(id + ' .back', {
            height: 90,
            top: 110
          }, 0).from(id + ' .back .circle', {
            marginTop: -50
          }, 0).from(id + ' .front', {
            height: 70,
            boxShadow: "0px -60px 10px -60px rgba(0,0,0,0.1)"
          }, 0).from(id + ' .front .circle', {
            marginTop: -90,
            backgroundColor: "#f069aa",
            backgroundPosition: "0 100px"
          }, 0).from(id + ' p', {
            duration: 0.4,
            opacity: 0
          }, 0.2);

          if (peel == false) {
            peelTL.to(id + ' .back', {
              duration: 0.2,
              opacity: 0
            }, 0.45);
          }

          setTimeout(function () {
            peelTL.play();
            setTimeout(function () {
              el.classList.add('pasted');
              el.style = '';
            }, 750);
          }, 800);
        }
      }
    }); // #endregion
    // #region Banners

    ScrollReveal().reveal('.sticker-banner-mobile', {
      delay: 600,
      scale: 1.2,
      easing: 'ease-out',
      duration: 200,
      opacity: 0
    }); // #endregion
    // #region Block 1 -Hero Block

    ScrollReveal().reveal('.heroslider.no-swiper .container:not(.justify-end) > div', {
      delay: 600,
      distance: '100px',
      origin: 'left',
      easing: 'ease-out',
      duration: 600,
      opacity: 0
    });
    ScrollReveal().reveal('.heroslider.no-swiper .container.justify-end > div', {
      delay: 600,
      distance: '100px',
      origin: 'right',
      easing: 'ease-out',
      duration: 600,
      opacity: 0
    }); // #endregion
    // #region Block 4 - Fifty Fifty Block Img

    ScrollReveal().reveal(".fifty-fifty-img-txt-block .image-wrapper", {
      delay: 600,
      distance: "100px",
      origin: "bottom",
      easing: "ease-out",
      duration: 600
    });
    ScrollReveal().reveal(".fifty-fifty-img-txt-block .content-wrapper", {
      delay: 600,
      distance: "50px",
      origin: "top",
      easing: "ease-out",
      duration: 600
    }); // #endregion
    // #region Block 5 - Fifty Fifty Block Img / Full Width

    ScrollReveal().reveal(".fifty-fifty-img-txt-full-width-block .image-right .img-wrapper img", {
      delay: 600,
      distance: "50px",
      origin: "right",
      easing: "ease-out",
      duration: 600
    });
    ScrollReveal().reveal(".fifty-fifty-img-txt-full-width-block .image-left .img-wrapper img", {
      delay: 600,
      distance: "50px",
      origin: "left",
      easing: "ease-out",
      duration: 600
    });
    ScrollReveal().reveal(".fifty-fifty-img-txt-full-width-block .image-right .content-wrapper", {
      delay: 600,
      distance: "50px",
      origin: "left",
      easing: "ease-out",
      duration: 600
    });
    ScrollReveal().reveal(".fifty-fifty-img-txt-full-width-block .image-left .content-wrapper", {
      delay: 600,
      distance: "50px",
      origin: "right",
      easing: "ease-out",
      duration: 600
    }); // #endregion
    // #region Block 6 - Columns (2)

    ScrollReveal().reveal(".columns-block .column-2:first-of-type", _defineProperty({
      delay: 600,
      distance: "50px",
      origin: "left",
      duration: 400,
      easing: "ease-out"
    }, "duration", 600));
    ScrollReveal().reveal(".columns-block .column-2:last-of-type", _defineProperty({
      delay: 600,
      distance: "50px",
      origin: "right",
      duration: 400,
      easing: "ease-out"
    }, "duration", 600)); // #endregion
    // #region Block 6 - Columns (3)

    ScrollReveal().reveal(".columns-block .column-3:nth-child(1)", {
      delay: 400,
      distance: "10px",
      origin: "bottom",
      scale: 0.8
    });
    ScrollReveal().reveal(".columns-block .column-3:nth-child(2)", {
      delay: 500,
      scale: 0.8
    });
    ScrollReveal().reveal(".columns-block .column-3:nth-child(3)", {
      delay: 600,
      scale: 0.8
    }); // #endregion
    // #region Block 6 - Columns (4)

    ScrollReveal().reveal(".columns-block .column-4:nth-child(1)", {
      delay: 400,
      distance: "10px",
      origin: "bottom",
      scale: 0.8
    });
    ScrollReveal().reveal(".columns-block .column-4:nth-child(2)", {
      delay: 500,
      scale: 0.8
    });
    ScrollReveal().reveal(".columns-block .column-4:nth-child(3)", {
      delay: 600,
      scale: 0.8
    });
    ScrollReveal().reveal(".columns-block .column-4:nth-child(4)", {
      delay: 700,
      scale: 0.8
    }); // #endregion
    // #region Block 11 - USPs

    ScrollReveal().reveal(".usps-block-block .swiper", _defineProperty({
      delay: 400,
      distance: "400px",
      origin: "right",
      duration: 300,
      easing: "ease-out"
    }, "duration", 600)); // #endregion
    // #region Block 13 - Featured Products

    ScrollReveal().reveal(".featured-products-block .info-box:nth-child(1)", {
      delay: 400,
      distance: "40px",
      origin: "bottom",
      easing: "ease-out",
      duration: 600
    });
    ScrollReveal().reveal(".featured-products-block .info-box:nth-child(2)", {
      delay: 600,
      distance: "60px",
      origin: "bottom",
      easing: "ease-out",
      duration: 600
    });
    ScrollReveal().reveal(".featured-products-block .info-box:nth-child(3)", {
      delay: 800,
      distance: "80px",
      origin: "bottom",
      easing: "ease-out",
      duration: 600
    });
    ScrollReveal().reveal(".featured-products-block .info-box:nth-child(4)", {
      delay: 1000,
      distance: "100px",
      origin: "bottom",
      easing: "ease-out",
      duration: 600
    }); // #endregion
    // #region Block 15 - News Block

    ScrollReveal().reveal(".news-block-block .post-item:nth-child(1)", {
      delay: 400,
      distance: "10px",
      origin: "bottom",
      scale: 0.8
    });
    ScrollReveal().reveal(".news-block-block .post-item:nth-child(2)", {
      delay: 500,
      scale: 0.8
    });
    ScrollReveal().reveal(".news-block-block .post-item:nth-child(3)", {
      delay: 600,
      scale: 0.8
    }); // #endregion
    // #region Block 16 - Awards

    ScrollReveal().reveal(".awards-block-block .swiper", {
      delay: 600,
      distance: "300px",
      origin: "left",
      duration: 600,
      easing: "ease-out"
    }); // #endregion
    // #region Block 33 - Fifty Fifty Enhanced Block

    ScrollReveal().reveal(".fifty-fifty-img-txt-enhanced-block .image-wrapper", {
      delay: 600,
      distance: "100px",
      origin: "bottom",
      easing: "ease-out",
      duration: 600
    });
    ScrollReveal().reveal(".fifty-fifty-img-txt-enhanced-block .content-wrapper", {
      delay: 600,
      distance: "50px",
      origin: "top",
      easing: "ease-out",
      duration: 600
    }); // #endregion
  }
});